const mapStyle = [
    // Remove noise
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { featureType: 'administrative', elementType: 'geometry', stylers: [{ visibility: 'off' }] },

    // Land
    { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#f2f2f0' }] },
    { featureType: 'landscape.man_made', elementType: 'geometry', stylers: [{ color: '#f0efeb' }] },

    // Water
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c0d8e4' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#9ab0bd' }] },

    // Roads
    { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }] },
    { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#e8e4dc' }] },
    { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#f0ede6' }] },
    { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#dbd8d0' }] },
    { featureType: 'road.arterial', elementType: 'geometry.fill', stylers: [{ color: '#fafaf8' }] },

    // Labels
    { elementType: 'labels.text.fill', stylers: [{ color: '#716e60' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f0' }] },
    { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#888888' }] },
    { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#666666' }] },
];

export default mapStyle;
